import { html } from 'lit';
import { i18n } from '@lingui/core';

export function renderModal(component) {
    const title = i18n.t({
        id: 'eid.title',
        message: 'Verify that you are you',
        comment: 'Title of the EID verification modal',
    });

    return html`
        <w-modal
            style="--w-c-modal-width: 464px"
            .show="${component.open}"
            @hidden="${component._handleModalHidden}"
        >
            <w-modal-header slot="header" .title="${title}"></w-modal-header>
            <p slot="content" class="font-light text-s">
                ${i18n.t({
                    id: 'eid.description',
                    message:
                        'Before you make contact, you need to verify with BankID. We do this so that the person on the other end can be confident in who they are talking to.',
                    comment: 'Description in the EID verification modal',
                })}
            </p>
            <w-modal-footer slot="footer">
                <w-button
                    variant="secondary"
                    @click="${component._handleCancelVerify}"
                >
                    ${i18n.t({
                        id: 'eid.modal.cancel',
                        message: 'Not now',
                        comment: 'Cancel button in EID verification modal',
                    })}
                </w-button>
                <w-button
                    variant="primary"
                    @click="${component._handleClickVerify}"
                >
                    ${i18n.t({
                        id: 'eid.modal.verify.button',
                        message: 'Verify with BankID',
                        comment: 'Verify button in EID verification modal',
                    })}
                </w-button>
            </w-modal-footer>
        </w-modal>
    `;
}
